// components/TopicCard.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import ShareLinkButton, { topicLink } from "./ShareLinkButton";
import SmartImg from "./SmartImg";

const TopicCard = ({ topic }) => {
  const navigate = useNavigate();

  if (!topic) return null;

  const { id, title, description, img } = topic;
  console.log(topic);

  const handleDetailClick = (e) => {
    e.preventDefault(); // Ngăn chặn hành vi mặc định của thẻ <Link> hoặc <button>
    // Xem chuyên đề không cần đăng nhập
    navigate(`/topic/${id}`);
  };

  return (
    <div onClick={handleDetailClick} className="block cursor-pointer">
      <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-[1.03] hover:shadow-2xl h-full flex flex-col">
        <SmartImg
          className="w-full h-48 object-cover rounded-t-xl"
          src={img}
          fallback={`https://placehold.co/400x200/E0E0E0/000?text=${title.replace(/\s/g, "+")}`}
          alt={title}
        />
        <div className="p-6 flex-grow flex flex-col justify-between">
          <div>
            <h3 className="text-xl font-bold text-gray-900 line-clamp-2">
              {title}
            </h3>
            <p className="mt-2 text-sm text-gray-600 line-clamp-3">
              {description}
            </p>
          </div>
          <div className="mt-4 flex items-center justify-between text-gray-500 text-sm">
            <ShareLinkButton
              url={topicLink(id)}
              title={`Chuyên đề: ${title}`}
              label="Chia sẻ"
              className="text-sm"
            />
            <button
              onClick={handleDetailClick}
              className="text-green-600 font-semibold hover:text-green-800 transition-colors duration-300 flex items-center"
            >
              Vào chuyên đề <ChevronRight size={16} className="ml-1" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopicCard;
